
<iframe
    class="application-frame" width="100%"
    [src]="applicationURL"></iframe>